module.exports = __webpack_public_path__ + "img/6db7467c59cee309ccd306443ef00558.833f0562.png";